/**
*  Get Block Column.
*
* @param {String} colClassName ClassName
* @returns {Array} Block column.
*/

const getBlockColumn = ( colClassName ) => {
return [
	'core/column',	{ 
		className: colClassName
	},
	[
		[
			'core/group',
			{
				className: 'page__content-column-content',
				lock: {
					remove: true,
					move: true,
				}
			},
		],
	]
];
};

export const blockColumns = [
[
	'core/columns',
	{
		className: 'page__content -columns -column-5 text',
		align: 'full',
		lock: {
			remove: true,
			move: true,
		}
		
	},
	[
		getBlockColumn( 'page__content-column-5-1'),
		getBlockColumn( 'page__content-column-5-2'),
		getBlockColumn( 'page__content-column-5-3'),
		getBlockColumn( 'page__content-column-5-4'),
		getBlockColumn( 'page__content-column-5-5'),
	] 
],
];